
import { useState, useEffect } from "react";
import { AppBar, Toolbar, IconButton, Box, Button, Menu, MenuItem, Typography, Divider, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import userLogo from "../assets/user-logo.svg";
import apolloLogo from "../assets/apollo-logo.jpg";
import aigLogo from "../assets/aig-logo.png";




const Header = () => {
    const [loggedUsername, setLoggedUsername] = useState("");
    const [appointmentType, setAppointmentType] = useState("book");
    //const accountId = localStorage.getItem('account_id');
    const navigate = useNavigate();
    const location = useLocation();
    const [anchorEl, setAnchorEl] = useState(null);
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const storedCustomer = JSON.parse(localStorage.getItem("customer"));
    const role = localStorage.getItem("role");
    const message = localStorage.getItem("loginMessage");
    const customer = JSON.parse(localStorage.getItem("customer"));
    // const accountId =
    //     customer?.account_id ||
    //     localStorage.getItem("account_id");
    const accountId = String(
        customer?.account_id || localStorage.getItem("account_id")
    );


    const gender = storedUser?.gender?.toLowerCase()
        || storedCustomer?.gender?.toLowerCase()
        || null;
    const logoSrc = accountId === "1" ? apolloLogo : accountId === "2" ? aigLogo : "/echobuddy-logo.png";
    const logoStyle = {
        height: accountId === "1" ? "45px" : accountId === "2" ? "38px" : "45px",
        width: accountId === "1" ? "auto" : accountId === "2" ? "auto" : "auto",
        objectFit: "contain",
    };

    useEffect(() => {
        // Check if on appointment pages
        const isAppointmentPage = location.pathname.startsWith("/appointment/");

        if (isAppointmentPage) {
            // Show patient name from user object for appointment pages
            const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
            setLoggedUsername(storedUser?.name || "Guest");
        } else if (role === "user") {
            setLoggedUsername(localStorage.getItem("name"));
        } else if (role === "customer") {
            const customer = JSON.parse(localStorage.getItem("customer"));
            if (customer) {
                setLoggedUsername(`${customer.firstname} ${customer.lastname}`);
            }
        } else {
            setLoggedUsername("Guest");
        }
    }, [location.pathname]);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogoutClick = () => {
        handleMenuClose();
        handleLogout();
    };

    const handleAppointmentToggle = (event, newType) => {
        if (newType !== null) {
            setAppointmentType(newType);
        }
    };

    const handleLogout = () => {
        // Check if current path is appointment booking related
        const currentPath = window.location.pathname;
        const isAppointmentPage = currentPath.includes('/appointment') || currentPath.includes('/booking');

        localStorage.clear();

        if (isAppointmentPage) {
            // Always redirect to appointment/login when on appointment/booking pages
            navigate('/appointment/login');
        } else if (role === 'user') {
            navigate('/');
        } else {
            navigate('/');
        }

        setTimeout(() => {
            localStorage.removeItem("user");
            localStorage.removeItem("name");
            localStorage.removeItem("account_id");
            localStorage.removeItem("customer");
            localStorage.removeItem("role");
            localStorage.removeItem("sessionComplete");
        }, 10);
    };

    const toggleButtonStyle = {
        textTransform: "none",
        borderRadius: 2,
        fontSize: "13px",
        fontWeight: 600,
        px: 2,
        border: "1px solid #4C41FF",
        color: "#4C41FF",
        backgroundColor: "white",

        "&.Mui-selected": {
            backgroundColor: "#4C41FF",
            color: "#fff",
            "&:hover": {
                backgroundColor: "#3c32cc",
            },
        },

        "&:hover": {
            backgroundColor: "rgba(76, 65, 255, 0.08)",
        },

        "&.Mui-disabled": {
            backgroundColor: "#ccc",
            color: "#666",
            borderColor: "#ccc",
        },
    };

    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: "white",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                borderBottom: "1px solid #ddd",
                height: { xs: "55px", sm: "60px" },
            }}
        >
            <Toolbar sx={{ display: "flex", alignItems: "center", px: { xs: 0.5, sm: 2 }, }}>
                {/* Left: Sidebar Toggle (Mobile) & Logo */}
                <Box sx={{ display: "flex", alignItems: "center", }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 1, sm: 1.5 },
                            p: { xs: 0.5, sm: 1 },
                            minWidth: 'fit-content',
                            maxWidth: { xs: '280px', sm: '350px', md: '400px' },
                            transition: 'all 0.3s ease',
                            overflow: 'hidden'
                        }}
                    >
                        <Box sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 0,
                            padding: '8px 10px',
                        }}>
                            {/* <img
                                src="/echobuddy-logo.svg"
                                alt="echoCare Logo"
                                style={{
                                    height: '34px',
                                    width: 'auto',
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    if (role === "user") {

                                        navigate("/patients");
                                    } else if (role === "customer" && message === "Customer login successful") {
                                        navigate("/appointment/booking");
                                        
                                    } else {
                                        navigate("/my-assessments");
                                    }

                                }}
                            /> */}
                            <img
  src="/echobuddy-logo.svg"
  alt="echoCare Logo"
  style={{
    height: '34px',
    width: 'auto',
    cursor: "pointer",
  }}
  onClick={() => {
    const path = location.pathname;

   
   if (path.includes("/appointment")) {
    navigate("/appointment/booking");
    return;
  }

    // Existing logic
    if (role === "user") {
      navigate("/patients");
    } else if (
      role === "customer" &&
      message === "Customer login successful"
    ) {
      navigate("/appointment/booking");
    } else {
      navigate("/my-assessments");
    }
  }}
/>
                            <Typography sx={{
                                fontSize: { xs: 20, md: 24 },
                                fontWeight: 700,
                                letterSpacing: 0.8,
                                color: '#1F2937',
                                padding: '8px 10px'
                            }}>
                                {accountId === "1" ? (
                                    <>
                                        MUSICC{" "}
                                        <span style={{ color: "#0d813dff" }}>Care</span>
                                    </>
                                ) : location.pathname.startsWith("/appointment/") ? (
                                    <>
                                        MUSICC{" "}
                                        <span style={{ color: "#0d813dff" }}>Care</span>
                                    </>
                                ) : accountId === "2" ? (
                                    "echoCare"
                                ) : (
                                    "echoCare"
                                )}
                            </Typography>
                            {/* <Typography
                                sx={{
                                    fontSize: { xs: 20, md: 24 },
                                    fontWeight: 700,
                                    letterSpacing: 0.8, color:
                                        '#1F2937'
                                }}>
                        {String(accountId) === "1" &&
 (message === "Login successful" ||
  message === "PIN Validate successfully") ? (
    <>
      MUSICC <span style={{ color: "#0d813dff" }}>Care</span>
    </>
) : (
    "echoCare"
)}
 </Typography> */}



                            {/* <Divider
                                orientation="vertical"
                                flexItem
                                sx={{ borderColor: '#D1D5DB', }}
                            /> */}
                            {/* <img
                                src={logoSrc}
                                alt="Logo"
                                style={logoStyle}
                            /> */}
                        </Box>

                    </Box>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        ml: "auto", // 🔥 pushes everything to right
                    }}
                >

                    {role === "customer" &&
                        message === "Login successful" &&
                        (location.pathname.startsWith("/appointment")) && (

                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => {
                                    if (location.pathname === "/appointment/booking") {
                                        navigate("/appointment/my-appointments");
                                    } else {
                                        navigate("/appointment/booking");
                                    }
                                }}
                                sx={{
                                    backgroundColor: "#4C41FF",
                                    textTransform: "none",
                                    borderRadius: 2,
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    mx: 2,
                                    "&:hover": {
                                        backgroundColor: "#3c32cc",
                                    },
                                }}
                            >
                                {location.pathname === "/appointment/booking"
                                    ? "My Appointments"
                                    : "Schedule Appointment"}
                            </Button>
                        )}




                    {/* Right: User Info */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto", }}>
                        <Box sx={{ textAlign: "right" }}>
                            <Typography sx={{
                                fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                color: "#1a1a1a",
                                lineHeight: 1.2,
                                fontWeight: 500
                            }}>
                                {loggedUsername}
                            </Typography>

                        </Box>

                        <Box sx={{ position: "relative" }}>
                            <IconButton onClick={handleMenuOpen} sx={{ padding: 0 }}>
                                <Box
                                    component="img"
                                    src={
                                        gender === "male"
                                            ? "/man.png"
                                            : gender === "female"
                                                ? "/woman.png"
                                                : userLogo
                                    }
                                    alt="User"
                                    sx={{
                                        width: { xs: 35, sm: 40, md: 45 },
                                        borderRadius: "50%",
                                        cursor: "pointer",
                                    }}
                                />
                            </IconButton>

                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                                PaperProps={{
                                    elevation: 3,
                                    sx: { borderRadius: 2, minWidth: 120, mt: 1 },
                                }}
                            >
                                {/* {role !== "user" && ( */}
                                <MenuItem
                                    onClick={() => {
                                        handleMenuClose(); // ✅ close the menu first
                                        if (location.pathname.startsWith("/appointment")) {
                                            navigate("/appointment/my-profile");
                                        } else {
                                            navigate("/my-profile");
                                        }
                                    }} // then navigate

                                    sx={{
                                        fontWeight: 500,
                                        "&:hover": {
                                            backgroundColor: "#f5f5f5",
                                        },
                                    }}
                                >
                                    My Profile
                                </MenuItem>
                                {/* )} */}

                                <MenuItem
                                    onClick={handleLogoutClick}
                                    sx={{
                                        fontWeight: 500,
                                        "&:hover": {
                                            backgroundColor: "#f5f5f5",
                                        },
                                    }}
                                >
                                    Logout
                                </MenuItem>
                            </Menu>
                            <Box
                                sx={{
                                    position: "absolute",
                                    bottom: 1,
                                    right: 1,
                                    width: { xs: 11, sm: 15 },
                                    height: { xs: 11, sm: 15 },
                                    backgroundColor: "#4CAF50",
                                    borderRadius: "50%",
                                    border: "2px solid white",
                                }}
                            />
                        </Box>

                    </Box>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
